<template>
  <div class="vertical-align-step-1" lang="tr">
    <form id="step1" method="POST" @submit="sendForm">
      <h3 class="main_question"><strong>1/4</strong>{{ $t('Fatura Bilgileriniz') }}</h3>
      <div class="row mb-1">
        <div class="col-md-6" v-if="form.companies">
          <div v-if="!isCorporate">
            <InputField
              v-model="form.id_identifier_number"
              v-mask="'###########'"
              name="id_identifier_number"
              class="mb-3"
              v-tippy="form.foreign_citizen ? $t('Yabancı Uyruk No Tooltip') : $t('T.C. Kimlik No Tooltip')"
              :placeholder="form.foreign_citizen ? $t('Yabancı Uyruk No') : $t('T.C. Kimlik No')"
              v-validate="'required|min:11|max:11'"
              :error="errors.first('id_identifier_number')"
              :disabled="isNewUser && Boolean(formCopy.id_identifier_number)"
              errorBox="id_identifier_number"
              :validateFields="fields['id_identifier_number']"
            />
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="container_check version_2">
                    {{ $t('Yabancı vatandaşım') }}
                    <input v-model="form.foreign_citizen" name="foreign-citizen" type="checkbox" value="true" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <InputField
            v-else
            v-model="form.tax_number"
            v-mask="'##########'"
            name="tax_number"
            v-tippy="$t('Vergi Numarası Tooltip')"
            :placeholder="$t('Vergi Numarası')"
            v-validate="'required|min:10|max:10'"
            :error="errors.first('tax_number')"
            errorBox="tax_number"
            :validateFields="fields['tax_number']"
          />
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <vue-tel-input
              id="phone-mask"
              @validate="mobilePhoneValidate"
              v-model="form.mobile"
              z
              class="form-control"
              :input-options="{ placeholder: $t('Cep Telefonu Numarası') }"
            ></vue-tel-input>
            <error-box field="mobile" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <InputField
              v-model="form.tax_office"
              name="tax_office"
              v-tippy="$t('Vergi Dairesi Tooltip')"
              :placeholder="$t('Vergi Dairesi')"
              v-validate="'required'"
              :error="errors.first('tax_office')"
              errorBox="tax_office"
              :validateFields="fields['tax_office']"
            />
          </div>
        </div>
      </div>

      <h3 class="main_question">{{ $t('Faaliyet Adresiniz') }}</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div class="clearfix">
              <v-select
                v-model="addressCity"
                :filterBy="filterSelect"
                :options="cities"
                class="wide"
                :class="{ 'is-invalid': errors.first('address-city') }"
                :searchable="false"
                label="name"
                name="address-city"
                v-validate="'required'"
                :placeholder="$t('Adres il')"
                value="id"
                @input="setAddressCity"
              >
                <span slot="no-options">{{ $t('Üzgünüz, belirtmiş olduğunuz il bulunamadı') }}</span>
              </v-select>
              <span v-show="errors.first('address-city')" class="show-invalid invalid-feedback">{{
                errors.first('address-city')
              }}</span>
              <error-box field="address.city_id" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="clearfix">
              <v-select
                v-model="addressDistrict"
                :filterBy="filterSelect"
                :options="addressDistricts"
                class="wide"
                :class="{ 'is-invalid': errors.first('address-county') }"
                v-validate="'required'"
                :searchable="false"
                label="name"
                name="address-county"
                :placeholder="$t('Adres ilçe')"
                value="id"
                @input="setAddressDistrict"
              >
                <span slot="no-options">{{ $t('Üzgünüz, belirtmiş olduğunuz ilçe bulunamadı') }}</span>
              </v-select>
              <span v-show="errors.first('address-city')" class="show-invalid invalid-feedback">{{
                errors.first('address-county')
              }}</span>
              <error-box field="address.district_id" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <textarea
            class="form-control"
            v-validate="'required'"
            name="fullAdress"
            :class="{ 'is-invalid': errors.first('fullAdress') }"
            v-model="form.address.fullAddress"
            :placeholder="this.$t('Adresinizi Giriniz')"
            rows="4"
          ></textarea>
          <span v-show="errors.first('fullAdress')" class="show-invalid invalid-feedback">{{
            errors.first('fullAdress')
          }}</span>
        </div>
      </div>
    </form>
    <MobileVerify
      :mobile="form.mobile"
      :limit-message="limitMessage"
      ref="mobileVerifyComponent"
      @mobile-verified="emailVerified()"
    />
  </div>
</template>
<script>
import InputField from './../InputField.vue';

export default {
  computed: {
    addressCity: {
      get: function () {
        if (this.form.address.city_id) {
          return {
            id: this.form.address.city_id,
            name: this.form.address.city_readable,
          };
        }

        return null;
      },
      set: function () {},
    },
    addressDistrict: {
      get: function () {
        if (this.form.address.district_id) {
          return {
            id: this.form.address.district_id,
            name: this.form.address.district_readable,
          };
        }

        return null;
      },
      set: function () {},
    },
    isCorporate() {
      if (this.form && this.form.companies) {
        const code = this.form.companies.data[0].companyType.data.code;
        if (['LIMITED', 'CORPORATION'].indexOf(code) > -1) {
          return true;
        }
      }
      return false;
    },
  },
  data() {
    return {
      cities: [],
      addressDistricts: [],
      form: {
        address: {},
        id_identifier_number: null,
        tax_number: null,
        tax_office: null,
      },
      mobileNumberIsValid: false,
      callback: null,
      limitMessage: null,
    };
  },
  props: {
    isNewUser: {
      type: Boolean,
    },
  },
  created() {
    this.startWaiting();
    this.createTestFunctions();
    this.$store.dispatch('getSelfWithCompanies').then(() => {
      const form = JSON.parse(JSON.stringify(this.$store.state.selfMeData));
      form.tax_office = form.companies.data[0].tax_office;
      form.tax_number = form.companies.data[0].tax_number;
      this.form = form;
      this.formCopy = JSON.parse(JSON.stringify(this.$store.state.selfMeData));
      if (this.form.address.city_id) {
        this.getDistricts(this.form.address.city_id, (districts) => {
          this.addressDistricts = districts;
        });
      }
      if (this.form.mobile == null) {
        this.form.mobile = '';
      }
      if (this.form.address.city_id) {
        this.getDistricts(this.form.address.city_id, (districts) => {
          this.addressDistricts = districts;
        });
      }
      this.endWaiting();
      // Set saved addres district
      setTimeout(() => {
        this.form.address.district_id = form.address.district_id;
        this.form.address.district_readable = form.address.district_readable;
      }, 1);
    });
    $axios.get('city').then((s) => {
      this.cities = s.data.data;
    });
  },
  methods: {
    emailVerified() {
      this.startWaiting();
      this.callback(true);
    },
    mobilePhoneValidate(event) {
      this.mobileNumberIsValid = event.valid;
    },
    setAddressCity(city) {
      if (!city) {
        this.form.address.city_id = null;
        this.form.address.city_readable = null;
        return;
      }

      this.form.address.city_id = city.id;
      this.form.address.city_readable = city.name;
      if (this.addressDistricts.length) {
        this.form.address.district_id = null;
        this.form.address.district_readable = null;
      }
      this.getDistricts(city.id, (districts) => {
        this.addressDistricts = districts;
      });
    },
    setAddressDistrict(district) {
      if (!district) {
        this.form.address.district_id = null;
        this.form.address.district_readable = null;

        return;
      }

      this.form.address.district_id = district.id;
      this.form.address.district_readable = district.name;
    },
    sendForm(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.mobileNumberIsValid) {
            window.Vue.$toasted.error(this.$t('AlertMessages.Lütfen geçerli bir telefon numarası girin'));
            return;
          }
          this.startWaiting();
          const form = JSON.parse(JSON.stringify(this.form));
          form.mobile = '+' + form.mobile.replace(/[^0-9.]/g, '');
          form.birthday = null;
          this.limitMessage = null;
          form.address.city_id = this.addressCity.id;
          form.address.district_id = this.addressDistrict.id;
          $axios
            .put('register/profile', form)
            .then((s) => {
              this.$toasted.show(this.$t('AlertMessages.Bilgileriniz kaydedildi'));
              this.callback = callback;
              if (form.mobile.startsWith('+90') && !s.data.data.is_mobile_verified) {
                this.endWaiting();
                const element = this.$refs.mobileVerifyComponent.$el;
                this.$refs.mobileVerifyComponent.resetModal();
                $(element).modal('show');
                return;
              }
              // eslint-disable-next-line node/no-callback-literal
              callback(true);
            })
            .catch((error) => {
              if (error.response && error.response.status === 429) {
                this.limitMessage = error.response.data.message;
                this.$toasted.show(this.$t('AlertMessages.Bilgileriniz kaydedildi'));
                this.callback = callback;

                if (form.mobile.startsWith('+90') && !form.is_mobile_verified) {
                  this.endWaiting();
                  const element = this.$refs.mobileVerifyComponent.$el;
                  this.$refs.mobileVerifyComponent.resetModal();
                  $(element).modal('show');
                  return;
                }

                // eslint-disable-next-line node/no-callback-literal
                callback(true);
              }
            });
        }
      });
    },
    getDistricts(cityID, callback) {
      $axios.get('district?city_id=' + cityID).then((s) => {
        callback(s.data.data);
      });
    },
    createTestFunctions() {
      this.selectDistrict();
      this.selectCity();
    },
  },
  components: {
    InputField,
  },
};
</script>
